import React, { FC } from 'react';
import interpolateContent from '../../../helpers/interpolate-content';

interface FieldTextAreaProps {
  readonly characterLimit?: number;
  readonly characterLimitLabel?: string;
  readonly disabled?: boolean;
  readonly error?: boolean;
  readonly onChange?: (value: string | number | null) => void;
  readonly placeholder?: string;
  readonly rows?: number;
  readonly value?: string;
}

const FieldTextArea: FC<FieldTextAreaProps> = ({
  characterLimit,
  characterLimitLabel,
  disabled,
  error,
  onChange,
  placeholder,
  rows,
  value,
}) => {
  let background = 'bg-light-blue';
  let ring = 'ring-inset ring-focus focus:ring-1';

  if (disabled) {
    background = 'bg-grey-50';
  }

  if (error) {
    background = 'bg-invalid-bg';
    ring = 'ring-inset ring-invalid ring-1';
  }

  return (
    <>
      <textarea
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full rounded-md outline-none px-6 py-4 placeholder-grey-600
          ${ring}
          ${background}
        `}
        onChange={(event) => {
          if (
            characterLimit === null ||
            event.target.value.length <= characterLimit
          ) {
            onChange(event.target.value);
          }
        }}
        rows={rows}
      />

      {characterLimit !== null && characterLimitLabel && (
        <span className="float-right mr-1 text-grey-800 text-xs">
          {interpolateContent(characterLimitLabel, value.length)}
        </span>
      )}
    </>
  );
};

FieldTextArea.defaultProps = {
  characterLimit: null,
  characterLimitLabel: null,
  disabled: false,
  error: false,
  onChange: () => ({}),
  placeholder: null,
  rows: 6,
  value: null,
};

export default FieldTextArea;
